
import { createContext, useContext } from 'react';

export const SyncRefreshContext = createContext<() => Promise<void>>(async () => {});

export function useSyncRefresh() {
  return useContext(SyncRefreshContext);
}
